const INVALID_ID_VALUES = new Set(["undefined", "null", "[object Object]", "NaN"]);

/**
 * Normalize company identifiers that may be a string id or populated object.
 * Rejects corrupted localStorage values such as "[object Object]".
 */
export const resolveCompanyId = (value) => {
  if (value == null || value === "") return null;

  if (typeof value === "string" || typeof value === "number") {
    const normalized = String(value).trim();
    if (!normalized || INVALID_ID_VALUES.has(normalized)) return null;
    return normalized;
  }

  if (typeof value === "object") {
    if (value.companyID != null) {
      const nested = resolveCompanyId(value.companyID);
      if (nested) return nested;
    }
    if (value._id != null && value._id !== "") return String(value._id);
    if (value.id != null && value.id !== "") return String(value.id);
  }

  return null;
};

export default resolveCompanyId;
